<div class="card card-hover h-100 bg-transparent">
  <div class="card-body d-flex gap-3">
    <backstage-product-icon [productId]="result.familyId"></backstage-product-icon>
    <div class="flex-grow-1 overflow-hidden">
      <a
        [appSearchResultLink]="result"
        [href]="result.url"
        class="h5 text-truncate-2 text-decoration-none text-gray-800 stretched-link mb-2">{{ result.title }}</a>
      <div class="small text-break d-flex flex-wrap gap-1">
        <span class="badge bg-gray-100 text-gray-700">{{ result.familyId | uppercase }}</span>
        <span class="badge bg-gray-100 text-gray-700">{{ result.version }}</span>
      </div>
    </div>
  </div>
</div>
